// 我们提供了监控 SDK 配套的 npm 包
import Vue from 'vue';
import watchdog from '@hll/watch-dog-jsutil';
import { getUrlParam, isHllApp, getStorage } from '@/utils';
import urlConfig from '@/config';
import { UNIQUE_ID } from './uniqueId';
// const host = location.hostname;
// const regHost = /-dev|-stg|-pre|localhost|^192\.168|^172\.20/.test(host);
const isUserApp = () => {
  let portType = getUrlParam('portType');
  return (
    isHllApp() &&
    portType == 'hlluser' &&
    !/HLLPorterApp/.test(navigator.userAgent)
  );
};

// 有些业务场景可直接拿到用户ID，有些则需要异步
const getCurrentUser = () => {
  const paramkey = isUserApp() ? 'user_fid' : 'driver_md5';
  const hash_id = getStorage('user_hash_fid') || getStorage('driver_hash_fid');
  const bizUserType = isHllApp()
    ? isUserApp()
      ? 'user_fid'
      : 'driver_md5'
    : 'hash_fid';
  const bizUserId = isHllApp() ? getUrlParam(paramkey) : hash_id;
  return Promise.resolve({
    bizUserId: JSON.stringify({ userId: bizUserId, uniqueId: UNIQUE_ID }),
    bizUserType // 仅用于开发者自己区分，bizUserId 实际代表了什么
  });
};

try {
  // 绑定业务中的用户ID
  getCurrentUser().then(({ bizUserId, bizUserType }) => {
    watchdog.setConfig({ bizUserId, bizUserType });
  });
  // 对于后端接口都返回 HTTP 200 的业务，强烈建议加上业务状态码的监控

  Vue.config.errorHandler = err => {
    console.error(err);
    setTimeout(() => {
      throw err;
    }, 100);
    // 在这个方法内可以将捕获到的错误进行上报到后台或者发送错误信息到 node 中间层
    // 上报到后台之后，在请错误请求到页面中进行可视化
  };
  watchdog.setConfig({
    _baseUrl: 'https://watch-dog.xiaolachuxing.com',
    silence: false,
    // silence: regHost,
    apiBizCodeParser(url, status, responseText) {
      if (url.indexOf(urlConfig.HOST_BODY) > -1 && status === 200) {
        // 解析 HTTP 响应中的业务状态码（看各业务接口的实际情况，这里只是示例用正则匹配）
        const match = (responseText || '').match(/^\{"ret":(\d+)/);
        return match ? match[1] : '';
      }
      return '';
    }
  });
} catch (err) {
  console.error('watchdog eroor:', err);
}
